import mapboxgl from 'mapbox-gl'
import { useEffect, useRef } from 'react'
import styled from 'styled-components'

interface MapCardProps {
  latitude?: number
  longitude?: number
}

mapboxgl.accessToken =
  'pk.eyJ1IjoiY2NhYnJhbC1kZXYiLCJhIjoiY2xkdWxudHlyMDcybDN2b3o0OHU3d3o3ZiJ9.WNw9-EHladqP7BiEQYKuaw'

export function MapCard({ latitude, longitude }: MapCardProps) {
  const mapContainer = useRef(null)
  const map = useRef<mapboxgl.Map | null>(null)

  useEffect(() => {
    if (!mapContainer.current) return
    if (!latitude || !longitude) return
    if (map.current) return
    const createdMap = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/streets-v12',
      center: [longitude, latitude],
      zoom: 12,
    })
    map.current = createdMap as mapboxgl.Map
  }, [latitude, longitude, mapContainer])

  if (!latitude || !longitude) {
    return null
  }

  return (
    <div className="h-[180px] overflow-hidden">
      <Map ref={mapContainer} className="map-container h-[160px] w-full" />
    </div>
  )
}

const Map = styled.div`
  canvas {
    border-radius: 5px;
  }

  .mapboxgl-ctrl {
    display: none;
  }
`
